export const SET_PATHS = 'routes/SET_PATHS';
export const SET_CONFIG = 'routes/SET_CONFIG';
export const SET_SELECTED_COUNTRY = 'routes/SET_SELECTED_COUNTRY';
